// extracted by mini-css-extract-plugin
export var actionButton = "_lk-0";
export var actionMenuContainer = "_lk-i";
export var bubble = "_lk-2";
export var bubbleActionMenu = "_lk-j";
export var bubbleContext = "_lk-6";
export var bubbleItems = "_lk-7";
export var customer = "_lk-3";
export var divider = "_lk-8";
export var fileList = "_lk-9";
export var hiddenComment = "_lk-o";
export var infoAbove = "_lk-a";
export var internal = "_lk-4";
export var lightActionButton = "_lk-1";
export var link = "_lk-b";
export var merchant = "_lk-5";
export var message = "_lk-c";
export var profilePicture = "_lk-e";
export var quillToolbarContainer = "_lk-f";
export var senderDate = "_lk-g";
export var senderDateCustomer = "_lk-h";
export var senderName = "_lk-d";
export var time = "_lk-k";
export var uploadedImage = "_lk-l";
export var username = "_lk-m";
export var xsmall = "_lk-n";